<template>
  <slot name="header" v-bind="{ closeModal }"></slot>
  <!-- CONTENT NOT STICKY, OVERFLOWED IF NEEDED -->
  <div
    class="py-5 px-6 space-y-4 overflow-y-auto flex-1 relative flex flex-col"
  >
    <slot name="top" v-bind="{ selectedAction, selectedItemPath, selectedItem, closeModal, selectDocuments, valid }"></slot>

    <div>
      <div>
        <div class="flex flex-wrap items-center space-y-3 py-3">
          <nav 
            class="-mb-px flex flex-1" 
            aria-label="Tabs"
          >
            <tab-panel-pill
              v-for="(item, index) in items"
              :key="index"
              :active="item.action === $formValues['frm-copyForm-copyForm-action']"
              :icon="item.icon"
              :text="$t(item.text)"
              @click.stop.prevent="changeModel(item.action)"
              class="pill__Tab-white"
            />
          </nav>
        </div>
      </div>
    </div>

    <slot v-bind="{ selectedAction }"></slot>
  </div>
  <!-- STICKY FOOTER - SUBMIT BUTTONS ALMOST -->
  <div class="flex-shrink-0 p-5 border-t border-gray-400">
    <slot name="bottom" v-bind="{ closeModal, valid, reload, selectedAction }"></slot>
  </div>
</template>

<script>
import bcFolderStore from '@/frontapp/store/bcFolder'
import bcSelectedStore from '@/frontapp/store/bcSelected'
import bcMoveCopyStore from '@/frontapp/store/bcMoveCopy'
import bcDocumentStore from '@/frontapp/store/bcDocument'
import { mapStores } from 'pinia'
import merge from 'lodash/merge'

export default {
  data() {
    return {
      items: [
        {
          action: 'move',
          icon: 'move',
          text: 'Move'
        },
        {
          action: 'copy',
          icon: 'copy',
          text: 'Copy'
        }
      ]
    }
  },
  computed: {
    selectedAction() {
      return this.$formValues['frm-copyForm-copyForm-action']
    },
    selectedItem() {
      return this.bcMoveCopyStore.selectedItem
    },
    selectedItemPath() {
      if (this.selectedItem) {
        // parent polozky
        const parents = []

        if (this.selectedItem.type !== 'domain') {
          parents.push(this.bcMoveCopyStore.selectedDomain.name)

          this.bcMoveCopyStore
            .listParents(this.selectedItem.type === 'folder' ? this.selectedItem.id : this.selectedItem.bc_folder_id)
            .forEach((item) => parents.push(item.name))

          // add last parent folder before document
          if (this.selectedItem.type === 'document' && this.selectedItem.bc_folder_id) {
            parents.push(this.bcMoveCopyStore.hashTable[this.selectedItem.bc_folder_id].name)
          }
        }

        // vybrana polozka = aktualni
        parents.push(this.selectedItem.name)

        return parents.join(' / ')
      }
      return null
    },
    selectDocuments() {
      return this.$route.matched[0].name !== 'BCFolder' && this.$route.matched[0].name !== 'BCHome'
    },
    valid() {
      let selectedItemsParentFolders = []
      if (!this.selectDocuments) {
        selectedItemsParentFolders = this.bcSelectedStore.listSelectedRoots.map((item) => item.type === 'folder' ? item.parent__bc_folder_id : item.bc_folder_id)
      }

      return this.selectedItem && this.selectedItem.can_edit && (!this.selectDocuments || this.selectedItem.type === 'document')
        && (
          this.selectedAction === 'copy' // copy can be used wherever
          || this.selectDocuments // move & copy to whatever document, current document is not selectable -> solved in MoveCopyNavItemRecursive.childredFiltered
          || ( // move only to different directories which are not childrens of currently selected folders or documents -> partialy solved in MoveCopyNavItemRecursive.childredFiltered
            (this.selectedItem.type === 'folder' && !selectedItemsParentFolders.includes(this.selectedItem.id))
            || (this.selectedItem.type === 'domain' && !selectedItemsParentFolders.includes(null))
          )
        )
    },
    ...mapStores(bcFolderStore, bcSelectedStore, bcMoveCopyStore, bcDocumentStore),
  },
  methods: {
    changeModel (action) {
      this.$formValues['frm-copyForm-copyForm-action:change'] = action
      this.bcMoveCopyStore.selectedItem = null
    },
    closeModal (close) {
      this.bcMoveCopyStore.selectedItem = null
      close()
    },
    async reload (payload) {
      this.bcMoveCopyStore.reset()
      this.bcMoveCopyStore.selectedItem = null
      if (this.$route.matched[0].name === 'BCFolder') {
        this.bcFolderStore.reset()
        await this.bcFolderStore.loadFolder(null)
        await this.bcFolderStore.loadFolder(parseInt(this.$route.params.rootId) !== 0 ? parseInt(this.$route.params.rootId) : parseInt(this.$route.params.id))
        if (this.$route.params.id) {
          this.bcFolderStore.enter(parseInt(this.$route.params.id))
        }

        this.bcSelectedStore.reload()
      
      } else if (this.$route.matched[0].name === 'BCHome') {
        this.bcFolderStore.reset()
        // reload home
        this.bcFolderStore.loadFolder(null)
        const rootFolder = merge({}, this.$presenter.rootFolder)
        rootFolder.id = 0 // fix create new folder / document on root because this.bcFolderStore.listChildren[this.bcFolderStore.current.id]
        this.bcFolderStore.current = rootFolder
        this.bcSelectedStore.reset(null, 'url', null, false)
      
      } else if (this.$route.matched[0].name === 'BCDocument') {
        if (this.$formValues['frm-copyForm-copyForm-action'] === 'move') {
          if (this.bcDocumentStore.document.bc_document_rev_id !== payload.$controls.copyForm.fromBcDocumentRevId) {
            await this.$router.replace({ 
              name: 'BCDocumentDetailRev',
              params: { revId: payload.$controls.copyForm.fromBcDocumentRevId } 
            })
          } else {
            await this.bcDocumentStore.loadDocument(this.bcDocumentStore.document.id, this.bcDocumentStore.document.bc_document_rev_id, this.bcFolderStore.show === 'shared')
            this.bcDocumentStore.loading = false
          }
        }
      }

      this.$formValues['frm-copyForm-copyForm-to__bc_document_id'] = null
      this.$formValues['frm-copyForm-copyForm-to__bc_folder_id'] = null
      this.$formValues['frm-copyForm-copyForm-to__domain_id'] = null
    },
  },
  watch: {
    selectedItem(item) {
      if (!item) {
        this.$formValues['frm-copyForm-copyForm-to__bc_document_id'] = null
        this.$formValues['frm-copyForm-copyForm-to__bc_folder_id'] = null
        this.$formValues['frm-copyForm-copyForm-to__domain_id'] = null
      
      } else if (item.type === 'domain') {
        this.$formValues['frm-copyForm-copyForm-to__bc_folder_id'] = null
        if (item.id !== this.bcMoveCopyStore.localBcId) {
          this.$formValues['frm-copyForm-copyForm-to__domain_id'] = item.id

        } else {
          this.$formValues['frm-copyForm-copyForm-to__domain_id'] = null
        }
      
      } else if (item.type === 'folder' && !this.selectDocuments) {
        this.$formValues['frm-copyForm-copyForm-to__bc_folder_id'] = item.id
      
      } else if (item.type === 'document') {
        this.$formValues['frm-copyForm-copyForm-to__bc_document_id'] = item.id
      }
    }
  }
}
</script>

<style lang="scss">
.TabPanel--Sticky {
  position: sticky;
  top: 90px;
  padding-top: 12px;
  z-index: 15;
  background: #fff;
}
</style>
